export async function flyIn() {
    const flyIns = document.querySelectorAll('[data-fly-in]');

    if (flyIns.length) {
        const { initFlyIns } = await import(/* webpackMode: "lazy" */ './inc/fly-in.async.js');

        initFlyIns(flyIns);
    }
}
